module.exports = __webpack_public_path__ + "img/ywAward-2.c6de91e2.png";